import { render } from "./WCCurrentOrderTypeBadge.vue?vue&type=template&id=3f719f20"
import script from "./WCCurrentOrderTypeBadge.vue?vue&type=script&lang=js"
export * from "./WCCurrentOrderTypeBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__